import React from 'react';

const FlexItem = ({ grow, shrink }) => {
  return /* @__PURE__ */ React.createElement("div", { style: { display: "block", flexGrow: grow, flexShrink: shrink } });
};

export { FlexItem };
//# sourceMappingURL=FlexItem.js.map
